<template>
<v-combobox ref="combo" v-model="internalValue" :items="items" :readonly="!personId" maxLength="30" label="بابت/توسط" v-bind="$attrs" v-on="$listeners" :search-input.sync="search" prepend-inner-icon="mdi-account-arrow-left" :error="offline"
  :error-messages="offline ? ['اتصال به سرور برقرار نیست'] : []" />
</template>

<script>
import _ from 'lodash'
import vueAxios from '../functions/vueAxios'

export default {
  name: 'MyAbouts',
  props: ['value', 'personId'],
  data() {
    return {
      internalValue: this.value || '',
      items: [],
      search: '',
      loadedOnce: false,
      offline: false,
      debouncedFetch: null,
      initialized: false
    }
  },
  watch: {
    value(val) {
      // همزمانی مقدار داخلی با prop
      this.internalValue = val || ''
      // اگر هنوز داده نیامده ولی personId هست → بلافاصله واکشی کن
      if (this.personId && !this.loadedOnce) {
        this.retrieveData()
      }
    },
    internalValue(val) {
      this.$emit('input', val || '')
    },
    personId(newVal) {
      // this.items = []
      // this.search = ''
      // this.loadedOnce = false
      // this.offline = false
      // this.internalValue = this.value || ''
      if (newVal) {
        this.retrieveData()
      }
    },
    search(val) {
      if (!this.initialized) return
      if (this.personId && val !== undefined) {
        this.debouncedFetch()
      }
    }
  },
  created() {
    this.debouncedFetch = _.debounce(this.retrieveData.bind(this), 500)
    this.$nextTick(() => this.initialized = true)
    if (this.personId) this.retrieveData()
  },
  methods: {
    async retrieveData() {
      if (!this.personId) {
        this.items = []
        return
      }
      this.offline = false
      try {
        const res = await vueAxios.get('/persons/abouts', {
          params: {
            mid: this.personId,
            q: this.search || ''
          }
        })

        if (res && Array.isArray(res)) {
          // فقط رشته‌ها رو نگه می‌داریم
          this.items = res.map(item => item.title)

          // بعد از آماده شدن داده‌ها مقدار انتخابی والد رو ست کن
          this.$nextTick(() => {
            this.internalValue = this.value || ''
          })
        } else {
          this.items = []
          this.offline = true
          console.warn('داده API معتبر نیست:', res)
        }
      } catch (e) {
        console.error('خطا در دریافت داده:', e)
        this.items = []
        this.offline = true
      } finally {
        this.loadedOnce = true
        this.$nextTick(() => {
          if (this.$refs.combo) {
            this.$refs.combo.validate(true)
          }
        })
      }
    }
  }
}
</script>
